import React, {useEffect, useState} from "react";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomTable, {CustomTablePagination, useHiddenColumns} from "../../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../../actions/snackbarActions"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import PageTitle from "../../Utils/smsTitle";
import {faNotesMedical} from "@fortawesome/free-solid-svg-icons/faNotesMedical";
import {dateConvert, formatDateTime} from "../../Utils/ConvertDate";
import {MiniHeader} from "../../Utils/Menu/MiniSubHeader";
import {ReusableRouteTabs} from "../../Utils/Dialogs/ReusableTabs";
import {history} from "../../../Helpers/history";
import Triage from "../../Triage/Triage"
import CustomDialog from "../../Utils/Dialogs/CustomDialog";
import {Container} from "../../Utils/styledComponents";
import ReusableTabs, {TabPanel} from "../../Utils/Dialogs/ReusableTabs";
import {Link} from "react-router-dom";
import DeleteDialog from "../../Utils/Dialogs/DeleteDialog";
import Label from "../../Utils/FormInputs/Label";
import TextField from "../../Utils/FormInputs/TextField";
import SelectInput, {CustomSelect} from "../../Utils/FormInputs/SelectInput";
import {useExcelReports} from "../../Utils/ReusableComponents/useExcelExport";
import moment from "moment";
import {getCurrentYear} from "../../Utils/ConvertDate";
import {useSelfRequestPrescription} from "../NewService/hooks/usePrescriptionSelfRequest";
import {useNewServiceRequest} from "../NewService/hooks/useNewServiceRequest";
import {useVisitPatientTriage} from "../../Triage/hooks/useVisitPatientTriage";
import {useDebounce} from "../../Lab/useDebounce";
import {useQuery} from "react-query";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import {FullScreenDialog} from "../../Utils/Dialogs/FullScreenDialog";
import {PatientMedicalHistory} from "../../DoctorsModule/PatientHistory/PatientMedicalHistory";
import {usePrint} from "../../Utils/Templates/usePrint";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";


const headData = [
    {id: 'count', numeric: false, disablePadding: false, label: 'Sl', hidden: false},
    {id: 'date', numeric: false, disablePadding: false, label: 'Date', hidden: false},
    {id: 'invoice', numeric: false, disablePadding: false, label: 'Invoice#', hidden: false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.', hidden: false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name', hidden: false},
    {id: 'phone_no', numeric: false, disablePadding: false, label: 'Phone', hidden: false},
    {id: 'provider_name', numeric: false, disablePadding: false, label: 'Provider Name', hidden: false},
    // { id: 'kin_phone_no', numeric: false, disablePadding: false, label: 'NOK Phone', hidden: false },
    {id: 'type', numeric: false, disablePadding: false, label: 'Visit Type', hidden: false},
    {id: 'item_status', numeric: false, disablePadding: false, label: 'Status', hidden: false},
    {id: 'action', numeric: false, disablePadding: true, label: 'Action', hidden: false},
];

const VisitList = ({actions, snackbar}) => {

    const [ids, setIds] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const [activePage, setActivePage] = useState(1)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [filters, setFilters] = useState({
        visitType: "",
        startDate: dateConvert(),
        endDate: dateConvert(),
        download: false,
        search: "",
    });
    const [paymentType, setPaymentType] = useState({value: '', label: 'All'})
    const [provider, setProvider] = useState({value: '', label: 'All'})
    const [providers, setProviders] = useState([])
    const [openCancel, setOpenCancel] = useState(false)
    const [cancel_visit_id, setCancelId] = useState('')
    const [isCanceled, setIsCanceled] = useState('idle')
    const [dialogTitle, setTitle] = useState('')
    const [openHistory, setOpenHistory] = useState(false)

    const isCancelResolved = isCanceled === 'resolved'

    const {patient_number, visit_id, visit_type, patient_name, age, gender, screen} = ids

    const obj = {patient_number, visit_id, visit_type, setOpenDialog, actions, activity_id: null}

    const {renderPrescription, handleClosePrescriptionDialog} = useSelfRequestPrescription(obj)

    const {renderService, handleCloseServiceDialog} = useNewServiceRequest(obj)

    const {triageProps} = useVisitPatientTriage(actions, obj)

    const {handleSubmitTriage, isPending: isPendingTriage} = triageProps;


    const [debouncedInputValue] = useDebounce(filters.search, 500)


    const visitListQuery = useQuery(
        ["visitListQuery", {
            ...filters,
            activePage,
            rowsPerPage,
            paymentType,
            provider,
            debouncedInputValue,
            isCancelResolved,
        }],
        async () => {
            if(filters.startDate && filters.endDate){
                try {

                    const response = await axios.get(
                        `${config.smsUrl}/cvisit/visits`,
                        {
                            params: {
                                start_date: moment(filters?.startDate).format("YYYY-MM-DD"),
                                end_date: moment(filters?.endDate).format("YYYY-MM-DD"),
                                // download: !(filters?.download),
                                visit_type: filters?.visitType,
                                page: activePage,
                                per_page: rowsPerPage,
                                search: debouncedInputValue,
                                payment_type: paymentType.value,
                                provider_id: provider.value
                            },
                        }
                    );
    
                    return response.data;
                } catch (error) {
                    //debugger
                    //console.log(error);
                }
            }
     
        },
        {
            retry: 1
        }
    );

    const {isError, isLoading, isSuccess, data: visitListData} = visitListQuery ?? {
        isSuccess: false,
        isError: true,
        isLoading: false,
        data: {items: [], pages: 0, total: 210}
    };

    useEffect(() => {
        axios.get(`${config.smsUrl}/cbilling/insurance_providers/list`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = !dt.data ? [] : dt.data;
            const list = arr.map(item => ({
                value: item.provider_id,
                label: item.provider_name
            }))
            setProviders(list);
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
    }, []);


    const handleOpenDialog = (item, screen) => {
        setOpenDialog(true)
        const {visit_id, patient_number, status, patient_name, age, gender} = item
        setIds({visit_id, patient_number, status, patient_name, age, gender, screen});

    };

    const handleCloseDialog = () => {
        // setOpenDialog(false)
        if (tabValue === 1) {
            handleClosePrescriptionDialog()
        } else {
            handleCloseServiceDialog()
        }

    };

    const handleChangeTabValue = (event, val) => {
        setTabValue(val)
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1)
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setActivePage(1);
    };


    const handleChangeActivePage = (page) => {
        setActivePage(page)
    };

    const handleChangePaymentType = (value) => {
        setPaymentType(value)
        setProvider({value: '', label: 'All'})
    }

    const handleChangeProvider = (value) => {
        setProvider(value)

    }

    const handleChangeFilter = (event) => {
        event.preventDefault();

        setFilters({
            ...filters,
            [event?.target?.name]: event?.target?.value
        });
    }


    const handleOpenCancel = (id, action) => {
        setCancelId(id)
        setTitle(action)
        setOpenCancel(true)

    };

    const handleCloseCancel = () => {
        setOpenCancel(false)
    };

    const handleCancel = (action) => {
        setIsCanceled('pending')
        axios.post(`${config.smsUrl}/cvisit/delete_visits_without_requests`, {visit_id: cancel_visit_id}).then(() => {
            actions.snackbarActions.snackSuccess(`Visit ${action} successfully`);
            setIsCanceled('resolved')
            setOpenCancel(false)
        }).catch(err => {
            errorMessages(err, null, actions)
            setIsCanceled('rejected')
        })
    }

    const closeSnackBar = () => {
        actions.snackbarActions.hideSnackbar()
    };


    const {exportExcel} = useExcelReports(actions, {
        file_name: "Visit List",
        url: "cvisit/visits",
        params: {
            start_date: moment(filters?.startDate).format("YYYY-MM-DD"),
            end_date: moment(filters?.endDate).format("YYYY-MM-DD"),
            visit_type: filters?.visitType,
            payment_type: paymentType.value,
            provider_id: provider.value
        },
    })


    const {openBar, type, message} = snackbar;


    const components = [
        {label: 'New Visit', path: '/newvisit'},
        {label: 'Visit List', path: '/visitlist'},
        {label: 'Consultation List', path: '/consultationlist'},
    ];

    const isTriage = screen === 'triage';

    const isService = screen === 'service';

    const title = isTriage ? 'Take Vitals' : tabValue === 0 ? 'Add Service' : tabValue === 1 ? 'Add Prescription' : ''


    const visitsArr = visitListData?.items?.map((item, idx) => {
        const v_type = {
            "1": "New Visit",
            "2": "Review patient",
            "4": "First-time patient"
        }

        const status = {
            0: (<span className="text-pending">Visit created</span>),
            1: (<span className='text-success'>Vitals taken</span>),
            2: (<span className='text-success'>Request added</span>),
            3: <span className='text-success'>Treatment ongoing</span>,
            4: <span className='text-error'>Visit Ended</span>
        }

        const action = {
            0: (
                <>
                    <button
                        onClick={() => handleOpenDialog(item, 'triage')}
                        className="btn btn-sm sms-info-btn mr-2 mb-2"
                    >
                        Triage
                    </button>

                    <button
                        onClick={() => handleOpenDialog(item, 'service')}
                        className="btn btn-sm sms-info-btn mr-2 mb-2"
                    >
                        Add request
                    </button>

                    <button
                        onClick={() => handleOpenCancel(item.visit_id, 'Cancel')}
                        className="btn btn-sm sms-gray-btn mb-2"
                    >
                        Cancel Visit
                    </button>
                </>

            ),

            1: (
                <>
                    <button
                        onClick={() => handleOpenDialog(item, 'service')}
                        className="btn btn-sm sms-info-btn mr-2 mb-2"
                    >
                        Add request
                    </button>

                    <button
                        onClick={() => handleOpenCancel(item.visit_id, 'End')}
                        className="btn btn-sm sms-gray-btn mb-2"
                    >
                        End Visit
                    </button>
                </>
            ),

            2: (
                <>
                    <button
                        onClick={() => handleOpenDialog(item, 'service')}
                        className="btn btn-sm sms-info-btn mr-2 mb-2"
                    >
                        Add request
                    </button>

                    <button
                        onClick={() => handleOpenCancel(item.visit_id, 'End')}
                        className="btn btn-sm sms-gray-btn mb-2"
                    >
                        End Visit
                    </button>
                </>
            ),

            3: (
                <>
                    <button
                        onClick={() => handleOpenDialog(item, 'service')}
                        className="btn btn-sm sms-info-btn mr-2 mb-2"
                    >
                        Add request
                    </button>

                    <button
                        onClick={() => handleOpenCancel(item.visit_id, 'End')}
                        className="btn btn-sm sms-gray-btn mb-2"
                    >
                        End Visit
                    </button>
                </>
            ),
        }

        const addRequestActionOnInsurance = {

            "4-1": (
                <button
                    onClick={() => handleOpenDialog(item, 'service')}
                    className="btn btn-sm sms-info-btn mr-2 mb-2"
                >
                    Add request
                </button>),
        }

        return {
            ...item,
            count: (rowsPerPage * (activePage - 1)) + idx + 1,
            date: formatDateTime(item.begin_datetime),
            type: v_type[item['visit_type']],
            item_status: status[item['status']],
            is_on_insurance: status[item['is_on_insurance']],
            patient_name: item["first_name"].concat(" ", item["last_name"]),
            invoice: item['is_on_insurance'] === 1 ? `${item.visit_id}/${getCurrentYear()}` : '',
            action: (
                <>
                    {
                        item.referal_status === 'TRUE' ?
                            <Link to={`/viewreferal/${item.visit_id}`}>
                                <button className="btn btn-sm sms-info-btn mr-1">
                                    View Referral
                                </button>
                            </Link>
                            :
                            null}

                    {action[item.status]}
                    {addRequestActionOnInsurance[`${item.status}-${item.is_on_insurance}`]}
                    <button
                        onClick={() => {
                            setOpenHistory(true)
                            setIds(item)
                        }}
                        className="btn btn-sm sms-info-btn  mb-2 ml-2"
                    >
                        View History
                    </button>
                </>
            )
        }
    })

    const {
        headCells, all_hidden, handleAllHeadCells, handleHeadCells
    } = useHiddenColumns(headData);


    const tabs = ['Service Request', 'Prescription Request']

    const {componentRef, handlePrint, fontSize} = usePrint('Medical History Report');

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            activePage={activePage}
            page={page}
            rowsPerPage={rowsPerPage}
            count={visitListData?.total ?? 0}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    return (
        <div>
            <PageTitle title="Visit List"/>

            <SubHeader title="Visit list" subTitle="Visit List">
                <FontAwesomeIcon icon={faNotesMedical}/>
            </SubHeader>

            <DeleteDialog
                message={`${dialogTitle.toLowerCase()}`}
                openDialog={openCancel}
                handleClose={handleCloseCancel}
                text="visit"
                title={`${dialogTitle} Visit`}
            >
                <button
                    className='btn sms-info-btn btn-sm'
                    onClick={handleCancel}
                >
                    {`${dialogTitle} Visit`}
                </button>

                <button
                    className="btn sms-grey-btn btn-sm"
                    onClick={handleCloseCancel}
                >
                    No
                </button>
            </DeleteDialog>


            <CustomDialog
                title={title}
                open={openDialog}
                handleClose={handleCloseDialog}
                maxWidth="lg"
                isContentOverflow={false}
            >
                {isTriage ?
                    <form onSubmit={handleSubmitTriage}>
                        <Triage {...{
                            ...triageProps,
                            patient_number,
                            patient: {patient_name, age, gender},
                            handleSubmitTriage
                        }}
                        />

                        <button
                            type="submit"
                            disabled={isPendingTriage}
                            className="btn btn-sm sms-btn"
                        >
                            {isPendingTriage ? 'Saving....' : 'Save Triage'}
                        </button>
                    </form>
                    :
                    null}

                {isService ?
                    <ReusableTabs
                        value={tabValue}
                        tabHeading={tabs}
                        handleChange={handleChangeTabValue}
                    >
                        <TabPanel value={tabValue} index={0}>
                            {renderService}
                        </TabPanel>

                        <TabPanel value={tabValue} index={1}>
                            {renderPrescription}
                        </TabPanel>
                    </ReusableTabs>
                    :
                    null}
            </CustomDialog>

            <FullScreenDialog open={openHistory} title='Visit Details' handleClose={() => setOpenHistory(false)}>
                <div ref={componentRef}>
                    {fontSize}
                    <PatientMedicalHistory {...{
                        actions,
                        visit: {visit_id: ids.visit_id, patient_number: ids.patient_number}
                    }}/>
                </div>
            </FullScreenDialog>

            <Container>
                <MiniHeader title='Visit List'/>

                <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>

                <MainSnackbar variant={type} message={message} open={openBar} handleCloseBar={closeSnackBar}/>

                {/*}<DateTimeFilter /*{...{ start_date, end_date, handleChange, submitted, handleSubmit, isPending: isPendingForm, type: 'date' }}  />*/}

                <div className="form-row">
                    <div className="form-group col">
                        <Label name="Visit Type"/>
                        <SelectInput
                            options={[
                                {text: "All", value: ""},
                                {text: "First-time patient", value: "4"},
                                {text: "Review patient", value: "2"},
                                {text: "New Visit", value: "1"},
                            ]}
                            required
                            name="visitType"
                            value={filters?.visitType}
                            onChange={handleChangeFilter}
                        />
                    </div>

                    <div className="form-group col">
                        <Label name='Start Date'/>
                        <TextField
                            type='date'
                            name='startDate'
                            value={filters?.startDate}
                            onChange={handleChangeFilter}
                        />
                    </div>

                    <div className="form-group col">
                        <Label name='End Date'/>
                        <TextField
                            type='date'
                            name='endDate'
                            value={filters?.endDate}
                            onChange={handleChangeFilter}
                        />
                    </div>

                    <div className="form-group col d-flex h-auto justify-content-around align-items-end">
                        <button
                            className="btn sms-info-btn"
                            type="button"
                            onClick={() => exportExcel(1)}
                        >
                                    <span>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M7.5 1.05a.45.45 0 0 1 .45.45v6.914l2.232-2.232a.45.45 0 1 1 .636.636l-3 3a.45.45 0 0 1-.636 0l-3-3a.45.45 0 1 1 .636-.636L7.05 8.414V1.5a.45.45 0 0 1 .45-.45ZM2.5 10a.5.5 0 0 1 .5.5V12c0 .554.446 1 .996 1h7.005A.999.999 0 0 0 12 12v-1.5a.5.5 0 0 1 1 0V12a2 2 0 0 1-1.999 2H3.996A1.997 1.997 0 0 1 2 12v-1.5a.5.5 0 0 1 .5-.5Z"
                                                fill="#fff"
                                            />
                                        </svg>
                                    </span>
                            &nbsp;&nbsp;Excel
                        </button>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 pl-0">
                        <Form.Group as={Row}>
                            <Col sm={2} lg={2}>
                                <Label name='Payment Type'/>
                            </Col>
                            <Col sm={8} lg={8}>
                                <CustomSelect value={paymentType} options={[{value: '', label: 'All'}, {
                                    value: 'cash',
                                    label: 'Cash'
                                }, {value: 'credit', label: 'Credit'}]}
                                              onChange={handleChangePaymentType}
                                              isClearable/>
                            </Col>
                        </Form.Group>
                    </div>

                    {paymentType.value === 'credit' ?
                        <div className="col-lg-4">
                            <Form.Group as={Row}>
                                <Col sm={2} lg={2}>
                                    <Label name='Provider'/>
                                </Col>
                                <Col sm={8} lg={8}>
                                    <CustomSelect value={provider} options={providers}
                                                  onChange={handleChangeProvider}
                                                  isClearable/>
                                </Col>
                            </Form.Group>
                        </div>
                        : null}
                </div>

                <CustomTable
                    headData={headCells}
                    handler={handleChangeFilter}
                    term={filters?.search}
                    data={visitsArr}
                    colSpan={headCells.length}
                    customPage
                    pagination={pagination}
                    records={visitListData?.total ?? 0}
                    handleChangeNextPage={handleChangeActivePage}
                    activePage={activePage}
                    total_count={visitListData?.total ?? 0}
                    searchInputName={"search"}
                    {...{all_hidden, handleAllHeadCells, handleHeadCells}}
                >

                    <TableBody>
                        {isLoading ?
                            <TableRow>
                                <TableCell
                                    colSpan={headCells.length}
                                    align="center"
                                >
                                    <img src="/images/smsloader.gif" alt="loader"/>

                                </TableCell>
                            </TableRow>
                            :
                            null}

                        {isSuccess ? visitsArr?.length > 0 ? visitsArr?.map(item => {

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={item.visit_id}
                                            className='mui-table-row'>

                                            {headCells.map((head) => (
                                                <TableCell key={head.id} hidden={head.hidden}>{item[head.id]}</TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })
                                :
                                <TableRow>
                                    <TableCell
                                        colSpan={headCells.length}
                                        align="center"
                                    >
                                        No records found
                                    </TableCell>
                                </TableRow>
                            :
                            null}

                        {isError ?
                            <TableRow>
                                <TableCell
                                    colSpan={headCells.length}
                                    align="center"
                                >
                                    The server did not return a successful response
                                </TableCell>
                            </TableRow>
                            :
                            null}
                    </TableBody>
                </CustomTable>

                {/*<div className="w-100 h-auto d-flex justify-content-end align-items-start">*/}

                {/*    <Pagination*/}
                {/*        count={visitListData?.pages ?? 0}*/}
                {/*        page={filters?.page}*/}
                {/*        onChange={handleChangePage}*/}
                {/*        hidePrevButton={filters?.page <= 1}*/}
                {/*        hideNextButton={filters?.page >= visitListData?.pages}*/}
                {/*    />*/}

                {/*</div>*/}

            </Container>
        </div>
    )
};

function mapStateToProps(state) {
    const {snackbar} = state;
    return {snackbar}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(VisitList);
